<template>
  <transition name="fade-opacity-lazy">
    <div class="alert-container"
         v-if="activeAlert"
         :class="[ type ]">
      <icon-default :color="getActiveColor"
                    @click="CLOSE_ACTIVE_ALERT">
        <IconCross/>
      </icon-default>
      {{ textAlert }}
    </div>
  </transition>
</template>

<script>
import IconDefault from "@/components/shared/icons/IconDefault.vue"
import IconCross from "@/assets/icons/ui/cross.svg?inline";
import {mapActions} from "vuex";

export default {
  name: "Alert",
  components: { IconDefault, IconCross },
  props: {
    activeAlert: {
      type: Boolean,
      required: true
    },
    textAlert: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    getActiveColor() {
      switch (this.type) {
        case 'error':
          return 'red';
        case 'success':
          return 'green';
        case 'warning':
          return 'orange';
        default:
          return 'default'
      }
    }
  },
  methods: {
    ...mapActions(["CLOSE_ACTIVE_ALERT"]),
  }
}
</script>

<style scoped lang="scss">
  .alert-container {
    z-index: 999;
    white-space: pre-wrap;
    text-align: center;
    width: fit-content !important;
    padding: 16px 24px;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 16px;
    font-size: 14px;
    border-radius: 5px;
    background-color: var(--color-dark-purple);
    color: var(--color-purple);
    border: 1px solid var(--color-light-purple);

    .icon-container {
      cursor: pointer;
      right: 6px;
      top: 6px;
      position: absolute;
      width: 12px !important;
      height: 12px !important;
    }

    &.error {
      border: 1px solid var(--color-red);
      background-color: rgba(var(--color-red-rgba), .2);
      color: var(--color-red);
    }
    &.success {
      border: 1px solid var(--color-green);
      background-color: rgba(var(--color-green-rgba), .2);
      color: var(--color-green);
    }
    &.warning {
      border: 1px solid var(--color-orange);
      background-color: rgba(var(--color-orange-rgba), .2);
      color: var(--color-orange);
    }
  }
</style>